import * as Yup from 'yup';
import {
  BOT_NAME_LENGTH_ERROR,
  MAX_BOT_NAME_LENGTH,
} from '../../../editor/features/configure/panels/sections/BotSettingsSection/BotName/BotName';
import ChatbotModel from '@mm/state/model/ChatbotModel';
import { BasicChatbot } from '@mm/state/interfaces/chatbot';

export enum BOT_CREATE_TYPE {
  SCRATCH = 'SCRATCH',
  TEMPLATE = 'TEMPLATE',
  CLONE = 'CLONE',
  CODE = 'CODE',
}

export type CreateBotFormValues = {
  botName: string;
  templateCode: string;
  createType: BOT_CREATE_TYPE;
  selectedSampleBot?: ChatbotModel;
  selectedCloneBot?: BasicChatbot;
};

export const getInitialValues = (params: {
  sampleBots: ChatbotModel[];
  bots: BasicChatbot[];
}) => {
  const { bots, sampleBots } = params;

  return {
    botName: '',
    templateCode: '',
    createType: BOT_CREATE_TYPE.SCRATCH,
    selectedSampleBot: sampleBots[0],
    selectedCloneBot: bots[0],
  };
};

const botNameSchema = Yup.string()
  .trim()
  .max(MAX_BOT_NAME_LENGTH, BOT_NAME_LENGTH_ERROR)
  .required('Bot Name Required');

const templateCodeSchema = Yup.string()
  .trim()
  .required('Code Required')
  .matches(/[0-9a-z]/, 'Invalid Code Format');

export const validationSchema = Yup.object().shape({
  createType: Yup.string(),
  botName: botNameSchema,
  templateCode: Yup.string()
    // @ts-ignore not sure if this is correct but seems to be working so won't fix
    .when('createType', {
      is: BOT_CREATE_TYPE.CODE,
      then: templateCodeSchema,
    }),
});

type BotLike = ChatbotModel | BasicChatbot;

export const getSelectedBot = (selectedBotId: number, bots?: BotLike[]) => {
  if (bots) {
    return bots.find(bot => bot.id === selectedBotId);
  }
};
